<template>
  <v-card
    outlined
    class="card-hover px-4 py-4 d-flex flex-column justify-space-between"
    height="142"
    elevation="0"
  >
    <div class="d-flex flex-column flex-grow-1">
      <p class="caption blue-grey--text text--darken-1 mb-2">
        {{
          routine.lastExecutedAt
            ? $t('routines.last_execution', {
                date: humanDate(routine.lastExecutedAt),
              })
            : $t('routines.not_executed_text')
        }}
      </p>

      <p
        class="subtitle-2 routine-name mb-2 blue-grey--text text--darken-3 text-truncate"
      >
        {{ routine.name }}
      </p>

      <div class="d-flex">
        <div v-if="routine.frequency" class="d-flex align-center">
          <v-icon small color="blue-grey darken-1">
            mdi-calendar-clock-outline
          </v-icon>
          <p
            class="button-text font-weight-medium font-size-12 blue-grey--text text--darken-1 mb-0 ml-1"
          >
            {{ $t(`routines.frequency.${routine.frequency}`) }}
          </p>
        </div>
      </div>
    </div>

    <div class="d-flex mt-2">
      <v-btn
        block
        color="blue lighten-2"
        elevation="0"
        rounded
        small
        @click="$emit('start')"
      >
        <v-icon color="primary">mdi-play-circle-outline</v-icon>
        <p class="font-weight-medium font-size-12 blue--text my-1 ms-2">
          {{ $t('common.button.start_routine') }}
        </p>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import { utils } from 'frontend-js-shared'

export default {
  name: 'RoutineCard',

  props: {
    routine: {
      type: Object,
      required: true,
    },
  },

  methods: {
    humanDate(date) {
      return utils.dates.humanDate(date)
    },
  },
}
</script>

<style lang="scss">
.routine-name {
  font-weight: 600 !important;
}
</style>
